export const expenditureColumn = [
    {
      key: "Type",
      title: "Type",
      width: "120px",
    },
    {
      key: "Budget",
      title: "Budget",
      width: "120px",
    },
    {
      key: "Spent",
      title: "Spent",
      width: "120px",
    },
    {
      key: "OpenPo",
      title: "Open Po's",
      width: "120px",
    },
    {
      key: "ApprovedRequest",
      title: "Approved Request",
      width: "120px",
    },
    {
      key: "ThisOrder",
      title: "This Order",
      Cell: (row: any) => <p>${row.rowData.ThisOrder}</p>,
      width: "120px",
    },
    {
      key: "OverUnder",
      title: "Over/Under",
      Cell: (row: any) => <p>${row.rowData.OverUnder}</p>,
      width: "120px",
    },
  ];